export default __webpack_public_path__ + "static/media/camera.e7f73203.png";